import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Fundraising's selection checkbox, drawn like the compliance ledger's ready circle: a light ring that
 * tints on hover and fills with a white check, in fundraising's blue. "Some selected" shows a dash.
 * The visible circle is 20px; an invisible ring widens the tap target to 44px wide by 40px tall — the
 * book's row height, so it never reaches into a neighbouring row.
 */
export const SelectCheckbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, checked, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    checked={checked}
    className={cn(
      "relative grid h-5 w-5 shrink-0 place-content-center rounded-full border-2 border-muted-foreground/40 text-primary-foreground transition-colors after:absolute after:-inset-x-3 after:-inset-y-2.5 after:content-[''] hover:border-primary hover:bg-primary/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-primary",
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="grid place-content-center">
      {checked === 'indeterminate' ? (
        <Minus className="h-3.5 w-3.5" strokeWidth={3} />
      ) : (
        <Check className="h-3.5 w-3.5" strokeWidth={3} />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
SelectCheckbox.displayName = 'SelectCheckbox';
